export default "__VITE_ASSET__DrSRSsDR__"